<template>
  <div
    v-if="hide_menu"
    class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden rounded-r-xl cursor-pointer h-[40px]"
    @click="toggleMenu"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>

  <div
    class="lg:flex fixed w-[95%] bg-white lg:w-[35%] lg:left-0 xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10 rounded-3xl heightfix overflow-y-auto"
    :class="{ hidden: !isMobile }"
    style="box-shadow: 0px 2px 30px 0px #01b0f926"
  >
    <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
    <div class="flex flex-col gap-4 w-full p-10">
      <div class="sticky top-0 z-10 bg-white border-b pb-4">
        <div class="flex items-start gap-3">
          <!-- Icon -->
          <!-- Loading -->
          <div
            v-if="isLoading"
            class="w-4 h-4 rounded-full flex-shrink-0 mt-1 bg-gray-200"
          ></div>

          <!-- Status -->
          <div
            v-else
            :class="
              coursePublished === 'Active' ? 'bg-green-200' : 'bg-red-200'
            "
            class="w-4 h-4 rounded-full flex-shrink-0 mt-1"
          ></div>
          <!-- Text -->
          <div class="min-w-0 flex-1">
            <div v-if="isLoading" class="space-y-2">
              <div class="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
              <div class="h-3 bg-gray-200 rounded w-1/2 animate-pulse"></div>
            </div>

            <template v-else>
              <h2 class="text-sm font-bold text-gray-800 break-words">
                {{ courseTitle }}
              </h2>
              <p class="text-xs flex items-center gap-1">
                <span
                  :class="
                    coursePublished === 'Active'
                      ? 'text-green-600'
                      : coursePublished === 'Inactive'
                      ? 'text-red-500'
                      : 'text-gray-500'
                  "
                >
                  {{ coursePublished }}
                </span>

                <span v-if="courseBatch" class="text-gray-500"
                  >· {{ courseBatch }}</span
                >
                -
                <span v-if="courseProgram" class="text-gray-500">{{
                  courseProgram
                }}</span>
              </p>
            </template>
          </div>
        </div>
      </div>
      <div
        ref="navMenu"
        @scroll="saveScroll"
        class="flex flex-col gap-5 relative w-full overflow-y-auto h-full"
      >
        <!-- Students -->
        <router-link
          :to="{ name: 'InstructorStudents', params: routeParams }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorStudents',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorStudents',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
          </svg>
          <p class="font-bold text-xs">Students</p>
        </router-link>

        <!-- Add Students -->
        <router-link
          :to="{ name: 'AddStudents' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl hidden transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'AddStudents',
            'hover:bg-gray-100 text-[#333333]': $route.name != 'AddStudents',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 21v-2a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v2" />
            <circle cx="6" cy="7" r="4" />
            <line x1="19" y1="8" x2="19" y2="16" />
            <line x1="15" y1="12" x2="23" y2="12" />
          </svg>
          <p class="font-bold text-xs">Add Students</p>
        </router-link>

        <!-- Messages -->
        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'InstructorNewMessages', params: routeParams }"
          @click="handleNavClick"
          class="flex items-center justify-between gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorNewMessages',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorNewMessages',
          }"
        >
          <div class="flex items-center gap-5">
            <svg
              class="w-5 h-5 flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
            <p class="font-bold text-xs">Messages</p>
          </div>
          <div
            v-if="this.user_count > 0"
            class="p-1 text-xs w-9 h-9 rounded-full border flex justify-center items-center font-bold"
            :class="{
              'bg-white text-[#0085DB] border-transparent':
                $route.name == 'InstructorNewMessages',
              'bg-[#0085DB] text-white border-none':
                $route.name != 'InstructorNewMessages',
            }"
          >
            {{ this.user_count }}
          </div>
        </router-link>

        <!-- Assignments -->
        <router-link
          v-if="checkinTheList('Assignments')"
          :to="{ name: 'InstructorAssignments' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': assignMentActive,
            'hover:bg-gray-100 text-[#333333]': !assignMentActive,
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          <p class="font-bold text-xs">Assignments</p>
        </router-link>

        <!-- Homework -->
        <router-link
          v-if="checkinTheList('Homework')"
          :to="{ name: 'HomeWorks' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl hidden transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': homeWorkActive,
            'hover:bg-gray-100 text-[#333333]': !homeWorkActive,
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
          </svg>
          <p class="font-bold text-xs">Homework</p>
        </router-link>

        <!-- Forums -->
        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'InstructorNewForums' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorNewForums',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorNewForums',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
            />
          </svg>
          <p class="font-bold text-xs">Forums</p>
        </router-link>

        <!-- Live Classes -->
        <router-link
          :to="{ name: 'InstructorClasses' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorClasses',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorClasses',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
          </svg>
          <p class="font-bold text-xs">Live Classes</p>
        </router-link>

        <!-- Assessment -->
        <router-link
          v-if="checkinTheList('Assessment')"
          :to="{ name: 'InstructorQuizs' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': assessmentActive,
            'hover:bg-gray-100 text-[#333333]': !assessmentActive,
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
          </svg>
          <p class="font-bold text-xs">Assessment</p>
        </router-link>

        <!-- Projects -->
        <router-link
          v-if="checkinTheList('Projects')"
          :to="{ name: 'InstructorBlogs' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorBlogs',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorBlogs',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
            />
          </svg>
          <p class="font-bold text-xs">Projects</p>
        </router-link>

        <!-- Grading -->
        <router-link
          :to="{ name: 'CourseComplete' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'CourseComplete',
            'hover:bg-gray-100 text-[#333333]': $route.name != 'CourseComplete',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="8" r="7" />
            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
          </svg>
          <p class="font-bold text-xs">Grading</p>
        </router-link>

        <!-- Lesson Polls -->
        <router-link
          :to="{ name: 'PollStudents' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'PollStudents',
            'hover:bg-gray-100 text-[#333333]': $route.name != 'PollStudents',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
          <p class="font-bold text-xs">Lesson Polls</p>
        </router-link>

        <!-- All Student -->
        <router-link
          :to="{ name: 'InstructorAllStudents' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl hidden transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InstructorAllStudents',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'InstructorAllStudents',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <p class="font-bold text-xs">All Student</p>
        </router-link>

        <!-- Grade Book -->
        <router-link
          :to="{ name: 'GradeBook' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': gradeBookActive,
            'hover:bg-gray-100 text-[#333333]': !gradeBookActive,
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path
              d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15z"
            />
          </svg>
          <p class="font-bold text-xs">Grade Book</p>
        </router-link>

        <!-- LiveClass Attendance -->
        <router-link
          :to="{ name: 'LiveclassAttendance' }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'LiveclassAttendance',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'LiveclassAttendance',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <p class="font-bold text-xs">LiveClass Attendance</p>
        </router-link>
        <router-link
          :to="{
            name: 'InternalMark',
            params: routeParams,
          }"
          @click="handleNavClick"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'InternalMark',
            'hover:bg-gray-100 text-[#333333]': $route.name != 'InternalMark',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <p class="font-bold text-xs">Internal Mark</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  computed: {
    ...mapGetters(["isAuthenticated", "userInfo", "permissionList"]),
    ...mapState(["navScrollPosition"]),

    savedScrollPosition() {
      if (
        this.navScrollPosition !== undefined &&
        this.navScrollPosition !== null
      ) {
        return this.navScrollPosition;
      }
      const stored = localStorage.getItem("instructorNavScrollPosition");
      return stored ? parseInt(stored, 10) : 0;
    },

    assignMentActive() {
      return (
        this.$route.name == "InstructorAssignments" ||
        this.$route.name == "InstructorAssignmentsSubmitted" ||
        this.$route.name == "SingleFeedback" ||
        this.$route.name == "OverallFeedback"
      );
    },
    homeWorkActive() {
      return (
        this.$route.name == "HomeWorks" ||
        this.$route.name == "AdminHomeworkDetail" ||
        this.$route.name == "HomeworkSingleFeedback" ||
        this.$route.name == "HomeworkOverallFeedback"
      );
    },
    assessmentActive() {
      return (
        this.$route.name == "InstructorQuizs" ||
        this.$route.name == "AssessmentOverallFeedback" ||
        this.$route.name == "QuizsScoreboard" ||
        this.$route.name == "AssessmentSingleFeedback"
      );
    },

    gradeBookActive() {
      return this.$route.path.includes("/gradebook");
    },
    routeParams() {
      return {
        course_id: this.$route.params.course_id,
        department_id: this.$route.params.department_id,
      };
    },
  },

  data() {
    return {
      isMobile: false,
      hide_menu: true,
      course_id: null,
      user_count: 0,
      scrollRestoreInterval: null,
      lastRouteChange: 0,
      courseTitle: "",
      courseBatch: "",
      coursePublished: "Inactive",
      courseProgram: "",
      isLoading: true,
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // this.fetchCourseTitle();
        this.lastRouteChange = Date.now();

        this.$nextTick(() => {
          this.restoreScrollPosition();
        });

        setTimeout(() => {
          this.restoreScrollPosition();
        }, 100);

        setTimeout(() => {
          this.restoreScrollPosition();
        }, 300);
      },
      immediate: false,
    },
    "$route.params.course_id": {
      handler(newId, oldId) {
        if (newId !== oldId) {
          // this.isLoading = true;
          this.fetchCourseTitle();
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.fetchCourseTitle();
    this.$nextTick(() => {
      this.restoreScrollPosition();
    });

    setTimeout(() => {
      this.restoreScrollPosition();
    }, 100);

    this.startScrollRestoreInterval();

    // const urlSegments = this.$route.path.split("/");
    // this.course_id = urlSegments.find((segment) => /^\d+$/.test(segment));
    // if (this.course_id) {
    //
    // }
  },

  beforeUnmount() {
    this.saveScroll();

    if (this.scrollRestoreInterval) {
      clearInterval(this.scrollRestoreInterval);
    }
  },

  methods: {
    ...mapMutations(["setNavScrollPosition"]),
    startScrollRestoreInterval() {
      if (this.scrollRestoreInterval) {
        clearInterval(this.scrollRestoreInterval);
      }

      this.scrollRestoreInterval = setInterval(() => {
        if (Date.now() - this.lastRouteChange < 2000) {
          const scrollPos = this.savedScrollPosition;
          if (this.$refs.navMenu && scrollPos > 0) {
            const currentScroll = this.$refs.navMenu.scrollTop;

            if (currentScroll === 0 && scrollPos > 0) {
              this.$refs.navMenu.scrollTop = scrollPos;
            }
          }
        }
      }, 500);
    },

    restoreScrollPosition() {
      const scrollPos = this.savedScrollPosition;

      if (this.$refs.navMenu && scrollPos > 0) {
        this.$refs.navMenu.scrollTop = scrollPos;

        this.$refs.navMenu.offsetHeight;

        this.$refs.navMenu.scrollTop = scrollPos;

        console.log(
          " Current scroll after restore:",
          this.$refs.navMenu.scrollTop,
        );
      } else {
        console.log(
          "Cannot restore - navMenu ref:",
          !!this.$refs.navMenu,
          "scrollPosition:",
          scrollPos,
        );
      }
    },

    saveScroll() {
      if (this.$refs.navMenu) {
        const currentScroll = this.$refs.navMenu.scrollTop;

        try {
          this.setNavScrollPosition(currentScroll);
        } catch (error) {
          console.error(" Vuex save failed:", error);
        }

        try {
          localStorage.setItem(
            "instructorNavScrollPosition",
            currentScroll.toString(),
          );
        } catch (error) {
          console.error(" localStorage save failed:", error);
        }
      }
    },

    handleNavClick() {
      this.saveScroll();
      this.lastRouteChange = Date.now();
    },

    checkinTheList(feature) {
      let check = this.permissionList.find((x) => x === feature);
      return check !== undefined;
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },

    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile;
    },

    async getstudentCount() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message_count/${this.course_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.user_count = resp.data.user_count;
          }
        });
    },
    async fetchCourseTitle() {
      const id = this.$route.params.course_id;
      this.isLoading = true;
      if (!id) {
        console.log(courseData?.program);
        this.courseTitle = "";
        this.courseBatch = "";
        this.courseProgram = "";
        this.coursePublished = "Inactive";
        this.isLoading = false;
        return;
      }

      const storageKey = `courseTitle_${id}`;
      const storedRaw = localStorage.getItem(storageKey);

      if (storedRaw) {
        try {
          const stored = JSON.parse(storedRaw);

          this.courseTitle = stored.title || "";
          this.courseBatch = stored.batch || "";
          this.courseProgram = stored.program || "";
          this.coursePublished =
            stored.status || (stored.is_published ? "Active" : "Inactive");
          this.isLoading = false;
          return;
        } catch (e) {
          localStorage.removeItem(storageKey);
        }
      }

      try {
        const resp = await axios.get(`${process.env.VUE_APP_API}/courses/`, {
          params: {
            Key: this.userInfo.token_key,
            id,
          },
        });

        if (resp.data.data.data.status === 200) {
          const rawData = resp.data.data?.data?.data;
          const courseData = Array.isArray(rawData) ? rawData[0] : rawData;
          const title = courseData?.title || "Untitled Course";
          const batch = courseData?.batch?.year || "";
          const program = courseData?.program?.name || "";
          const status = courseData?.is_published ? "Active" : "Inactive";

          this.courseTitle = title;
          this.courseBatch = batch;
          this.courseProgram = program;
          this.coursePublished = status;

          localStorage.setItem(
            storageKey,
            JSON.stringify({
              title,
              batch,
              program,
              status,
            }),
          );
        }
      } catch (err) {
        console.error("Course fetch error:", err);
        this.coursePublished = "Inactive";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
